// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider-module--divider--9dbda3"};